import axios from "axios";
import { SERVICEURL } from "../appconfig";
import { attachSessionInterceptors } from "./setupAxios";

export const apiClient = axios.create({
  baseURL: SERVICEURL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Token ekleme + süresi dolmuş oturum akışı `setupAxios` içinde tek yerde tanımlı.
// Bu instance varsayılan axios'un interceptor'larını miras almadığı için ayrıca takılıyor.
attachSessionInterceptors(apiClient);

export default apiClient;
